/**
 * Student Portal Service - API client for a student's own profile,
 * dashboard, academics, and assignments
 */
import api from '../utils/api';

const studentPortalService = {
  getProfile: async () => {
    try {
      return await api.get('/api/student-portal/profile');
    } catch (error) {
      console.error('Error fetching student profile:', error);
      throw error;
    }
  },

  getDashboard: async (termId) => {
    try {
      return await api.get('/api/student-portal/dashboard', { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching student dashboard:', error);
      throw error;
    }
  },

  getAnnouncements: async (limit) => {
    try {
      return await api.get('/api/student-portal/announcements', { params: { limit } });
    } catch (error) {
      console.error('Error fetching student announcements:', error);
      throw error;
    }
  },

  getEnrollmentStatus: async () => {
    try {
      return await api.get('/api/student-portal/enrollment-status');
    } catch (error) {
      console.error('Error fetching enrollment status:', error);
      throw error;
    }
  },

  getHostelStatus: async () => {
    try {
      return await api.get('/api/student-portal/hostel/status');
    } catch (error) {
      console.error('Error fetching hostel status:', error);
      throw error;
    }
  },

  getTransportStatus: async () => {
    try {
      return await api.get('/api/student-portal/transport/status');
    } catch (error) {
      console.error('Error fetching transport status:', error);
      throw error;
    }
  },

  getGrades: async (termId) => {
    try {
      return await api.get('/api/student-portal/grades', { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching grades:', error);
      throw error;
    }
  },

  getTimetable: async () => {
    try {
      return await api.get('/api/student-portal/timetable');
    } catch (error) {
      console.error('Error fetching timetable:', error);
      throw error;
    }
  },

  getFees: async (termId) => {
    try {
      return await api.get('/api/student-portal/fees', { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching fees:', error);
      throw error;
    }
  },

  getAttendance: async (days, termId) => {
    try {
      return await api.get('/api/student-portal/attendance', { params: { days, term_id: termId } });
    } catch (error) {
      console.error('Error fetching attendance:', error);
      throw error;
    }
  },

  // ---- Assignments ----

  listMyAssignments: async (termId, assignmentId) => {
    try {
      const params = {};
      if (termId) params.term_id = termId;
      if (assignmentId) params.assignment_id = assignmentId;
      return await api.get('/api/student-portal/assignments/my-assignments', { params });
    } catch (error) {
      console.error('Error fetching my assignments:', error);
      throw error;
    }
  },

  getAssignment: async (assignmentId) => {
    try {
      return await api.get(`/api/student-portal/assignments/${assignmentId}`);
    } catch (error) {
      console.error('Error fetching assignment:', error);
      throw error;
    }
  },

  submitAssignmentFile: async (assignmentId, formData) => {
    try {
      return await api.post(`/api/student-portal/assignments/${assignmentId}/submit-file`, formData);
    } catch (error) {
      console.error('Error submitting assignment file:', error);
      throw error;
    }
  },

  submitAssignment: async (assignmentId, answers) => {
    try {
      return await api.post(`/api/student-portal/assignments/${assignmentId}/submit`, { answers });
    } catch (error) {
      console.error('Error submitting assignment:', error);
      throw error;
    }
  },

  // ---- Course Modules ----

  listCourseModules: async () => {
    try {
      return await api.get('/api/student-portal/course-modules');
    } catch (error) {
      console.error('Error fetching course modules:', error);
      throw error;
    }
  },

  completeModuleItem: async (itemId) => {
    try {
      return await api.post(`/api/student-portal/course-modules/items/${itemId}/complete`);
    } catch (error) {
      console.error('Error completing module item:', error);
      throw error;
    }
  },

  uncompleteModuleItem: async (itemId) => {
    try {
      return await api.delete(`/api/student-portal/course-modules/items/${itemId}/complete`);
    } catch (error) {
      console.error('Error un-completing module item:', error);
      throw error;
    }
  }
};

export default studentPortalService;
